//src/core/components/page/HomePage/meta.ts
import { BASE_URL, BUSINESS_NAME, } from "@/core/constants/business";
export const WEBPAGE_META = {
    title: `Home | ${BUSINESS_NAME}`,
    meta_description: "Northern Virginia Foodies",
    image: `https://${BASE_URL}/images/gallery/andrew-sample-nothern-virginia-foodies-photo-1.jpg`,
};
